'use strict';

var _require = require('../exportJwtPrivateClaimKeys'),
    START_DATE = _require.START_DATE,
    END_DATE = _require.END_DATE,
    ROLE = _require.ROLE;

module.exports = {
  MS_ACCOUNT_ID: 'sig_ms_account_id',

  /**
   * @deprecated Use the fields from the exportJwtPrivateClaimKeys directly.
   */
  START_DATE: START_DATE,
  END_DATE: END_DATE,
  ROLE: ROLE
};